import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Badge, Dropdown } from 'react-bootstrap';
import './PolicySummaryHeader.scss';
import { InfoDisplay } from '../InfoDisplay/InfoDisplay';
import * as label from '../../../shared/util/label'
import { useHistory } from 'react-router-dom';
import { PolicyDtoRead } from '../../model/PolicyDtoRead';
import { ConfirmModal } from '../../../shared/components/confirmModal';
import CustomerNewPolicy from '../customer-policy-action/Customer-Policy-Action';
import { Modal } from '../../../components/components/Modal/Modal';
import { PolicyDto } from '../../model/PolicyDto';
import { PolicyEventDto } from '../../model/PolicyEventDto';
import { CommonUtility } from '../../../Services/CommonUtility';
import * as constant from '../../../shared/util/constant';
import { RootState } from '../../../shared/store';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomerPolicyCancelEndorse from '../customer-policy-action/customer-policy-cancel-endorse';
import moment from "moment";
import Logger from '../../../shared/services/Logger';
import CustomerPolicyListService from '../CustomerPolicyListService';
import { uuid } from '../../../shared/util/uuid';
import { PolicyLOBReadDto } from '../../model/PolicyLOBReadDto';
import { CustomerInsuredName } from '../../model/CustomerInsuredName';
import { Customer_CoInsured } from '../../model/Customer-CoInsured';
import CustomerPolicyDelete from '../customer-policy-action/customer-policy-delete';
import CustomerPolicyMove from '../customer-policy-action/customer-policy-move';
import { AbilityContext } from '../../../shared/abilities/AbilityContext';

interface PolicySummaryHeaderProps {
    termValue?: string;
    polTermStatus?: string;
    calCulatedpolTermStatus?: string;
    policyType?: string;
    policyStatusMap: Record<string, { backgroundColor: string }>;
    fullTermPremium?: number;
    // Button
    onActionSelect: (action: string) => void;
    disabledActions?: string[];
    isEditPolicyActivated?: boolean;
    policySummary: PolicyDtoRead;
    polEventId?: string;
}
interface StatusConfig {
    icon: IconProp;
    variant: string;
}

interface PolicyTypeConfig {
    icon: IconProp | [string, string]; // Support both single string and array format
}

//menu configuration
const POLICY_ACTIONS: PolicyActionOption[] = [
    { key: 'new', icon: 'plus', label: 'New' },
    { key: 'rewrite', icon: 'pen-to-square', label: 'Rewrite' },
    { key: 'compare', icon: 'code-compare', label: 'Compare' },
    { key: 'endorse', icon: 'file-pen', label: 'Endorse' },
    { key: 'renew', icon: 'sync', label: 'Renew' },
    { key: 'cancellation', icon: 'ban', label: 'Cancellation' },
    { key: 'move', icon: 'arrow-right', label: 'Move'},
    { key: 'delete', icon: 'trash', label: 'Delete', disabled: true },
];

const POLICY_TYPE_CONFIG: Record<string, PolicyTypeConfig> = {
    'Homeowners': { icon: 'home' },
    'HOME': { icon: 'house-user' },
    'Auto': { icon: 'car' },
    'Personal': { icon: 'user' },
    'Commercial': { icon: 'building' },
    'Umbrella': { icon: 'umbrella' },
    'Special Form': { icon: 'shield-alt' },
    'Basic Form': { icon: 'file-alt' },
    'HO1': { icon: 'home' },
    'HO2': { icon: 'home' },
    'HO3': { icon: 'home' },
    'HO4' :{icon: 'key'},
    'HO5' :{icon: 'home'},
    'HO7' :{icon: 'home'},
    'HO8' :{icon: 'home'},
    'HO6' :{icon: 'building'},
    'HOA - Homeowners' :{icon: 'home'},
    'HOB - Homeowners' :{icon: 'home'},
    'HOC - Homeowners' :{icon: 'home'},
    'HOC - Renters' :{icon: 'key'},
    'HOB - Renters' :{icon: 'key'},
    'Default': { icon: 'file' },
    'Earthquake':{icon:'house-damage'},
    'Boat':{icon:'sailboat'},
    'Inland Marine':{icon:'briefcase'},
    'Wind Policy':{icon:'wind'},
    'Mobile Home':{icon:'home'},
    'HOB - Condo':{icon:'building'},
    'HOC - Condo':{icon:'building'},
    'DP3':{icon:'fire'},
    'DP3 - Condo' :{icon: 'fire'},
    'DP1':{icon:'fire'},
    'Dwelling Fire':{icon:'fire'},
    'Recreational Vehicles' : {icon: 'caravan'},
    'Package' :{icon: 'boxes-packing'},
    'Package (P)' :{icon: 'boxes-packing'},
    'Private Passenger Auto' :{icon:'car'},
    'Specialty (P)' :{icon: 'scale-balanced'},
    'Umbrella (P)' :{icon: 'umbrella'},
    'Flood' :{icon: 'water'},
    'Excess Flood' :{icon: 'water'},
    'Motorcycle' :{icon: 'motorcycle'}
};

const STATUS_CONFIG: Record<string, StatusConfig> = {
    'Active': {
        icon: 'check-circle',
        variant: 'success'
    },
    'Cancelled': {
        icon: 'ban',
        variant: 'danger'
    },
    'Expired': {
        icon: 'calendar-times',
        variant: 'danger'
    },
    'Include': {
        icon: 'plus-circle',
        variant: 'secondary'
    },
    'Non-Renewed': {
        icon: 'times-circle',
        variant: 'danger'
    },
    'Not Taken': {
        icon: 'exclamation-circle',
        variant: 'warning'
    },
    'Quote': {
        icon: 'file-invoice',
        variant: 'info'
    },
    'Renewed': {
        icon: 'sync',
        variant: 'success'
    },
    'Rewritten': {
        icon: 'pen',
        variant: 'success'
    },
    'Pending': {
        icon: 'clock',
        variant: 'warning'
    },
    'Default': {
        icon: 'circle-info',
        variant: 'secondary'
    }
};

// Add interface for menu options
interface PolicyActionOption {
    key: 'new' | 'rewrite' | 'compare' | 'endorse' | 'renew' | 'cancellation' | 'move' | 'delete';
    icon: IconProp;
    label: string;
    disabled?: boolean;
}

export const PolicySummaryHeader: React.FC<PolicySummaryHeaderProps> = ({
    termValue,
    polTermStatus,
    calCulatedpolTermStatus,
    lobCodeValue,
    polTypeLobValue,
    formTypeValue,
    policyType,
    policyStatusMap,
    disabledActions,
    fullTermPremium,
    isEditPolicyActivated,
    policySummary,
    polEventId,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();

    // Get Declaration Name: API value or fallback to first + last name
    const declarationName = policySummary?.declarationName?.trim()
        ? policySummary.declarationName
        : [policySummary?.insuredFirstName, policySummary?.insuredLastName].filter(Boolean).join(' ');
    
    let customerInfo = useSelector((state: RootState) => state?.customerSlice);
    const businessType= constant.policyActionSummaryConstant.Personal_Lines_businessTypeId;
    const polTypeLobId= constant.policyActionSummaryConstant.HomeOwner_LobId;    
    const[selectedTransaction, setSelectedTransaction]= useState<string>(constant.EventTransactionType.NBS);
    const[customerId, setCustomerId]= useState<string>(policySummary.custId);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalTitle, setModalTitle] = useState<string>('');
    const [selectedAction, setSelectedAction] = useState<string>('');
    const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);    
    const[customerName, setCustomerName]= useState<string>(customerInfo?.customerSummary?.firstName + ' ' + customerInfo?.customerSummary?.lastName);
    const statusStyle = polTermStatus && policyStatusMap[polTermStatus]
        ? policyStatusMap[polTermStatus]
        : {};

        const [policyDetail, setPolicyDetail] = useState<PolicyDto | undefined>(undefined);
        const policyId = policySummary.id ? policySummary.id : '';
        const policyDetailService = new CustomerPolicyListService();

        const ability = useContext(AbilityContext);
        const canUserDeletePolicy = ability.can('delete', 'Policy', constant.ScreenName.POLICY);


        function groupUniqueLobs(policyDetail: PolicyDto) {
            if (!policyDetail.policyLineOfBusinesses) return [];

            // Find the latest event by seqNum
            const latestEvent = policyDetail.policyEvents.reduce((latest, current) =>
                (current.seqNum ?? 0) > (latest.seqNum ?? 0) ? current : latest
            );
            // Filter LOBs for the latest event
            const lobsForLatestEvent = policyDetail.policyLineOfBusinesses.filter(
                lob => lob.polEventId === latestEvent.id
            );
            // Deduplicate LOBs by lobCodeId
            const uniqueLobs = lobsForLatestEvent.filter(
                (lob, idx, arr) => arr.findIndex(l => l.lobCodeId === lob.lobCodeId) === idx
            );

            // 2. For each unique LOB, deduplicate all sub-entities by id
            return uniqueLobs.map(lob => {
                // Deduplicate locations
                const policyLocations = (lob.policyLocations || []).filter(
                    (loc, idx, arr) => arr.findIndex(l => l.id === loc.id) === idx
                ).map(loc => ({
                    ...loc,
                    // Deduplicate homes
                    policyHomes: (loc.policyHomes || []).filter(
                        (home, idx, arr) => arr.findIndex(h => h.id === home.id) === idx
                    ),
                    // Deduplicate home replacement costs
                    policyHomeReplacementCosts: (loc.policyHomeReplacementCosts || []).filter(
                        (cost, idx, arr) => arr.findIndex(c => c.id === cost.id) === idx
                    ),
                }));

                // Deduplicate coverages
                const policyCoverages = (lob.policyCoverages || []).filter(
                    (cov, idx, arr) => arr.findIndex(c => c.id === cov.id) === idx
                );

                // Deduplicate additional interests
                const policyAdditionalInterests = (lob.policyAdditionalInterests || []).filter(
                    (ai, idx, arr) => arr.findIndex(a => a.id === ai.id) === idx
                );

                return {
                    ...lob,
                    policyLocations,
                    policyCoverages,
                    policyAdditionalInterests,
                };
            });
        }

        const clonePolicyForRenewRewrite = (newPolicyDto: PolicyDto): PolicyDto => {
            if (!policyDetail) return newPolicyDto;

            // Get unique LOBs with deduped sub-entities
            const uniqueLobs = groupUniqueLobs(policyDetail);
            const policyEvents: PolicyEventDto[] = [];
            const policyLineOfBusinesses: PolicyLOBReadDto[] = [];
            const policyInsureds: CustomerInsuredName[] = [];
            const policyCoInsureds: Customer_CoInsured[] = [];

            const newPolEventId = uuid();
            // Create new event
            policyEvents.push({
                id: newPolEventId,
                polId: newPolicyDto.id,
                policyCoInsureds: policyDetail?.policyCoInsureds?.map(coIns => ({
                    ...coIns,
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                })) || [],
            });

            uniqueLobs.forEach(lob => {

                // Find the original event for this LOB
                const origEvent = (policyDetail.policyEvents || []).find(e => e.id === lob.polEventId);

                // Assign new IDs to LOB and all sub-entities
                const policyLocations = (lob.policyLocations || []).map(loc => ({
                    ...loc,
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                    policyHomes: (loc.policyHomes || []).map(home => ({
                        ...home,
                        polId: newPolicyDto.id,
                        polEventId: newPolEventId,
                    })),
                    policyHomeReplacementCosts: (loc.policyHomeReplacementCosts || []).map(cost => ({
                        ...cost,
                        polId: newPolicyDto.id,
                        polEventId: newPolEventId,
                    })),
                }));

                const policyCoverages = (lob.policyCoverages || []).map(cov => ({
                    ...cov,
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                }));

                const policyAdditionalInterests = (lob.policyAdditionalInterests || []).map(ai => ({
                    ...ai,
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                }));

                policyLineOfBusinesses.push({
                    ...lob,
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                    policyLocations,
                    policyCoverages,
                    policyAdditionalInterests,
                });

                policyInsureds.push(...(policyDetail?.policyInsureds || []).map(ins => ({
                    ...ins,
                    id: uuid(),
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                })));
                policyCoInsureds.push(...(origEvent?.policyCoInsureds || []).map(coIns => ({
                    ...coIns,
                    id: uuid(),
                    polId: newPolicyDto.id,
                    polEventId: newPolEventId,
                })));
            });

            const isCancelOrEndorse = selectedAction === constant.policyActionConstant.CANCELLATION || selectedAction === constant.policyActionConstant.ENDORSE;
            return {
                ...newPolicyDto,
                fullTermPremium: isCancelOrEndorse ? policyDetail.fullTermPremium : undefined,
                policyTypeId: policyDetail.policyTypeId,
                policyEvents,
                policyLineOfBusinesses,
                policyInsureds,
                policyCoInsureds,
            };
        };
        
        const createPolicyDtoToPass = (action:string) =>{
            const newPolicyId = (action === constant.policyActionConstant.CANCELLATION || action === constant.policyActionConstant.ENDORSE)? policySummary.id: uuid();
            
            // For RENEW: effective date = current expiration, expiration = effective + 1 year
            let polEffDate: Date;
            let polExpDate: Date;
            
            if (action === constant.policyActionConstant.NEW) {
                polEffDate = new Date();
                polExpDate = CommonUtility.addToCurrentDate(1,'years');
            } else if (action === constant.policyActionConstant.RENEW) {
                polEffDate = policySummary.polExpDate;
                polExpDate = CommonUtility.addToDate(polEffDate, 1, 'years');
            } else {
                polEffDate = policySummary.polEffDate;
                polExpDate = policySummary.polExpDate;
            }
            
            let policyDto: PolicyDto = {
            id: newPolicyId,
            policyNumber: action === constant.policyActionConstant.NEW ? '': policySummary.policyNumber,
            custId: customerId,
            polEffDate: polEffDate,
            polExpDate: polExpDate,
            sourceId: action === constant.policyActionConstant.NEW ? '' : policySummary.sourceId,
            sourceTypeId: action === constant.policyActionConstant.NEW ? '' : policySummary.sourceTypeId,
            typeOfBusId: action === constant.policyActionConstant.NEW ? businessType : policySummary.typeOfBusId,
            polTypeLobId: action === constant.policyActionConstant.NEW ? '' : policySummary.polTypeLobId,
            policyEvents: [],
            issuedState: action === constant.policyActionConstant.NEW ? '' : policySummary.issuedState,
            priorPolicyId: (action === constant.policyActionConstant.REWRITE || action === constant.policyActionConstant.RENEW) ? policySummary?.id : policySummary?.priorPolicyId,
            companyId: action === constant.policyActionConstant.NEW ? '' : policySummary?.companyId,
            writingCompanyId: action === constant.policyActionConstant.NEW ? '' : policySummary?.writingCompanyId,
            policyTypeId: action === constant.policyActionConstant.NEW ? '' : policySummary?.policyTypeId,
        };
        
            const isCancelOrEndorse = action === constant.policyActionConstant.CANCELLATION || action === constant.policyActionConstant.ENDORSE;

            const isRenewOrRewrite =
                action === constant.policyActionConstant.RENEW ||
                action === constant.policyActionConstant.REWRITE;

            if ((isCancelOrEndorse || isRenewOrRewrite) && policyDetail) {
                const cloned = clonePolicyForRenewRewrite(policyDto);
                return cloned;
            }  
            return policyDto;
        } 

    const IsCurrentPolicyLatest = (): boolean => {
            if (!customerInfo?.policies || customerInfo.policies.length === 0) {
                return false; // No policies available
            }

            // Filter policies by the current policy's policyNumber
            const matchingPolicies = customerInfo.policies.filter(
                (policy: PolicyDto) => policy.policyNumber === policySummary.policyNumber
            );

            if (matchingPolicies.length === 0) {
                return false; // No matching policies found
            }

            // Find the policy with the latest effective date
            const latestPolicy = matchingPolicies.reduce((latest, current) => {
                const latestEffDate = new Date(latest.polEffDate || 0).getTime();
                const currentEffDate = new Date(current.polEffDate || 0).getTime();
                return currentEffDate > latestEffDate ? current : latest;
            });

            // Check if the current policy is the latest
            return latestPolicy.id === policySummary.id;
        };

        const onActionSelect = async (action: string) => {
            if (selectedAction !== action) {
                setPolicyDetail(undefined); // Reset policy detail when action changes
            }
            setSelectedAction(action);
            try {
                if (!policyDetail || policyDetail.id !== policyId) {
                    const detail = await policyDetailService.getPolicyDetail(policyId);
                    setPolicyDetail(detail);
                }

            } catch (error) {
                toast.error(constant.ERROR_MESSAGE_LOAD, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: constant.AUTO_CLOSE
                });
                Logger.logError(error.toString());
                return;
            }

            switch (action) {
                case constant.policyActionConstant.REWRITE:
                case constant.policyActionConstant.RENEW:
                    setSelectedTransaction( action === constant.policyActionConstant.RENEW ? constant.EventTransactionType.RWL : constant.EventTransactionType.REW);    
                    setModalTitle(
                        (action === constant.policyActionConstant.RENEW ? 'Renew Policy for ' : 'Rewrite Policy for ') +
                        customerName
                    );
                    IsCurrentPolicyLatest()
                        ? setShowModal(true)
                        : setShowConfirmModal(true);
                    break;
                case constant.policyActionConstant.NEW:    
                    setSelectedTransaction(constant.EventTransactionType.NBS);
                    setModalTitle(constant.policyActionSummaryConstant.NewModalTitle + customerName);   
                    setShowModal(true);             
                    break;
                case constant.policyActionConstant.ENDORSE:
                    setSelectedTransaction(constant.EventTransactionType.PCH)
                    setModalTitle('Endorsement #' + policySummary.policyNumber + ' ('+ CommonUtility.formateDate(policySummary.polEffDate) +' - Continuous)');   
                    setShowModal(true);  
                    break;  
                case constant.policyActionConstant.CANCELLATION:
                    setSelectedTransaction(constant.EventTransactionType.XLC);
                    setModalTitle('Cancellation - #' + policySummary.policyNumber + ' for '+ customerName);   
                    setShowModal(true);  
                    break;
                case constant.policyActionConstant.MOVE:
                    setModalTitle(constant.MovePolicy.MOVE_POLICY);
                    setShowModal(true);
                    break;
                case constant.policyActionConstant.DELETE:
                    setSelectedTransaction(constant.EventTransactionType.DEL);
                    setModalTitle('Delete - #' + policySummary.policyNumber + ' for '+ customerName);   
                    setShowModal(true);  
                    break;
                default:
                    console.warn(`Unhandled action: ${action}`);
            }
        };

      const renderModalBody = (selectedAction : string) => {
        switch (selectedAction) {
            case constant.policyActionConstant.NEW:
            case constant.policyActionConstant.REWRITE:           
            case constant.policyActionConstant.RENEW:            
                return (
                    <div className='modal-div-class'>
                        <CustomerNewPolicy                          
                            selectedTransaction={selectedTransaction}                         
                            defaultPolicyDto={createPolicyDtoToPass(selectedAction)}
                            selectedAction={selectedAction}
                            onCloseModal={() => setShowModal(false)}
                        />
                    </div>
                );
            case constant.policyActionConstant.ENDORSE:
            case constant.policyActionConstant.CANCELLATION:
                 return (
                    <div className='cancelmodal-div-class'>
                        <CustomerPolicyCancelEndorse                          
                            selectedTransaction={selectedTransaction}                         
                            defaultPolicyDto={createPolicyDtoToPass(selectedAction)}
                            selectedAction={selectedAction}
                            onCloseModal={() => setShowModal(false)}
                        />
                    </div>
                );
            case constant.policyActionConstant.DELETE:
                 return (
                    <div className='cancelmodal-div-class'>
                        <CustomerPolicyDelete
                            policyId={policyId}
                            selectedAction={selectedAction}
                            onCloseModal={() => setShowModal(false)}
                        />
                    </div>
                );
            case constant.policyActionConstant.MOVE:
                return (
                    <div className='cancelmodal-div-class'>
                        <CustomerPolicyMove
                            policyId={policyId}
                            currentCustId={policySummary.custId || ''}
                            onCloseModal={() => setShowModal(false)}
                        />
                    </div>
                );
            default:
                return <div>Action not implemented</div>;
        }
    };

    const statusBadgeClass = `policy-header-status-badge--${calCulatedpolTermStatus?.replaceAll(' ', '').replaceAll('-', '').toLowerCase()}`;


    return (
        <div className="policy-summary-header flex-grow-1">
            <div className="d-flex justify-content-between align-items-start">
                <div>
                    <div className="header-row">
                        <h2 className="term-title">{termValue}</h2>
                        {polTermStatus && (
                            <Badge
                                className={`policy-header-status-badge ${statusBadgeClass}`}
                            >
                                <FontAwesomeIcon
                                    icon={STATUS_CONFIG[polTermStatus]?.icon || STATUS_CONFIG.Default.icon}
                                    className="me-1"
                                />
                                {polTermStatus}
                            </Badge>
                        )}
                    </div>
                    <div className="subtitle-row">
                        {policyType && (
                            <span className="subtitle-item">
                                <FontAwesomeIcon
                                    icon={POLICY_TYPE_CONFIG[policyType]?.icon as IconProp || STATUS_CONFIG.Default.icon}
                                />
                                <span>{policyType}</span>
                            </span>
                        )}
                        {declarationName && (
                            <InfoDisplay
                                caption="Declaration Name"
                                value={declarationName}
                            />
                        )}
                    </div>
                    
                </div>
                {!isEditPolicyActivated &&
                    <div className='d-flex align-items-center gap-3'>
                        <InfoDisplay
                            caption="Full Premium" bordered
                            value={fullTermPremium ? `$${fullTermPremium.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}` : '0.00'}
                        />
                        <Dropdown align="end">
                            <Dropdown.Toggle
                                variant="outline-primary"
                                id="policy-actions-dropdown"
                                className="btn-icon"
                            >
                                <FontAwesomeIcon icon="ellipsis-vertical" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {POLICY_ACTIONS.map(action => (
                                    <Dropdown.Item
                                        key={action.key}
                                        onClick={() => onActionSelect(action.key)}
                                        disabled={
                                            disabledActions?.includes(action.key) ||
                                            (action.key === 'delete' && !canUserDeletePolicy)
                                        }
                                        className='dropdown-item-custom'                                   
                                    >
                                        <FontAwesomeIcon
                                            icon={action.icon}
                                            className="me-2"
                                            fixedWidth
                                        />
                                        {action.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                }
            </div>

            <Modal
            title={modalTitle}
            verticallyCentered={true}
            show={showModal}
            toggle={() => setShowModal(!showModal)}
            body={renderModalBody(selectedAction)}
            className="custom-modal"                            
            />


           <ConfirmModal
                          modaltitle="Confirmation"
                          showConfirmation={showConfirmModal}
                          setConfirmation={(isModalOpen) => setShowConfirmModal(isModalOpen)}
                          body={`${constant.policyActionSummaryConstant.Renew_Rewrite_Confirmation_Popup_MSG} ${selectedAction.charAt(0).toUpperCase() + selectedAction.slice(1)}?`}
                          closeButtonClick={() => {
                              setShowConfirmModal(false)                             
                          }} // Close the modal
                          successButtonClick={() => {
                            setShowConfirmModal(false);
                            setShowModal(true);                            
                          }}
                          closeButtonLabel="No"
                          successButtonLabel="Yes"
                      />
        </div>
    );
};